const categories = [
  {
    icon: 'ri-stethoscope-line',
    title: 'Médecins spécialistes',
    desc: 'Cardiologues, dermatologues, pédiatres, gynécologues… Prise de RDV en temps réel sur l\'agenda du praticien.',
    tag: 'RDV instantané',
    color: 'primary',
  },
  {
    icon: 'ri-test-tube-line',
    title: 'Laboratoires d\'analyses',
    desc: 'Bilans sanguins, prélèvements spécialisés. Créneaux réels, suggestions d\'alternatives si complet.',
    tag: 'Agenda temps réel',
    color: 'secondary',
  },
  {
    icon: 'ri-scan-line',
    title: 'Centres de radiologie',
    desc: 'IRM, scanner, échographie. Comparez les disponibilités sur 7 jours glissants.',
    tag: 'Multi-centres',
    color: 'primary',
  },
  {
    icon: 'ri-capsule-line',
    title: 'Pharmacies',
    desc: 'Trouvez la pharmacie la plus proche. Avantage dédié aux patients partenaires.',
    tag: 'Avantage partenaires',
    color: 'accent',
  },
  {
    icon: 'ri-mental-health-line',
    title: 'Paramédical',
    desc: 'Kinésithérapeutes, orthophonistes, ostéopathes, infirmiers à domicile.',
    tag: 'À domicile possible',
    color: 'secondary',
  },
  {
    icon: 'ri-24-hours-line',
    title: 'Pharmacies de garde',
    desc: 'Consultation en direct des pharmacies ouvertes selon l\'heure et votre quartier.',
    tag: 'Ouvertes maintenant',
    color: 'primary',
  },
];

export default function Categories() {
  return (
    <section id="categories" className="py-20 md:py-28 bg-background-50">
      <div className="px-4 md:px-8 lg:px-12 max-w-7xl mx-auto">
        <div className="max-w-2xl mb-14">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-primary-600 mb-3">
            Un écosystème complet
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 leading-tight mb-4">
            Tous les acteurs de votre santé, <span className="italic text-primary-600">réunis.</span>
          </h2>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed">
            Une seule plateforme pour trouver médecins, laboratoires, radiologues, pharmacies
            et paramédicaux à Rabat. Filtrage par ville, quartier et proximité géographique.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((c, idx) => (
            <div
              key={c.title}
              className="group relative p-7 rounded-2xl bg-background-100 hover:bg-background-50 border border-background-200 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className={`w-14 h-14 flex items-center justify-center rounded-xl mb-5 ${
                c.color === 'primary' ? 'bg-primary-100' :
                c.color === 'accent' ? 'bg-accent-100' : 'bg-secondary-100'
              }`}>
                <i className={`${c.icon} text-2xl w-6 h-6 flex items-center justify-center ${
                  c.color === 'primary' ? 'text-primary-700' :
                  c.color === 'accent' ? 'text-accent-700' : 'text-secondary-700'
                }`} />
              </div>
              <h3 className="font-heading text-xl font-semibold text-foreground-950 mb-2">{c.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{c.desc}</p>
              <div className="flex items-center justify-between">
                <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[0.7rem] font-semibold ${
                  c.color === 'primary' ? 'bg-primary-100 text-primary-800' :
                  c.color === 'accent' ? 'bg-accent-100 text-accent-800' : 'bg-secondary-100 text-secondary-800'
                }`}>
                  {c.tag}
                </span>
                <i className="ri-arrow-right-line text-foreground-400 group-hover:text-primary-600 group-hover:translate-x-1 transition-all w-5 h-5 flex items-center justify-center" />
              </div>
              <span className="absolute top-5 right-5 text-[0.65rem] font-mono text-foreground-300">0{idx + 1}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}